import { FormattedMessage } from "react-intl";

const IncidentMonitoring = () => {
    return (
        <div>
            <p>
                <FormattedMessage
                    id="JiraServiceManagementPricingPageTeam24.features.incidentMonitoring.content.body"
                    defaultMessage="Keep tabs on logging and monitoring tools with heartbeat monitoring. Receive a notification if a system goes down for quick action."
                />
            </p>
        </div>
    );
};

export default IncidentMonitoring;
